// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602251940/js/" + chunkId + "." + {"44":"b44800fd","225":"6cc8c48c","481":"5c135318","486":"f9ad2765","770":"fa7b2c3a"}[chunkId] + ".0.15512246511951178.chunk.js";
};